import React, {Component} from 'react';
import {endpoints, http} from '../../configs/http';
import {toast, ToastContainer} from "react-toastify";
import {NavLink} from "react-router-dom";
import {Loader} from "react-overlay-loader";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
var qs = require('qs');

class Verify extends Component {
    constructor() {
        super();
        this.state = {

            loading: false,

            verified: false,
            failure: false





        };

    }
    componentDidMount() {
        // console.log(qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).search)
        console.log(qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).trxref)



        this.verifyTransaction()

    }

    verifyTransaction(){
        let trxref = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).trxref

        if(!trxref){
            return
        }
        this.setState({
            loading: true,
            failure: false
        })

        http
            .get(endpoints.VERIFY_PAYMENT.replace(':reference', trxref).replace(':trxref',trxref))
            .then(async (resp) => {
                console.log(resp);
console.log(resp.responseCode )
                if (resp.responseCode !== "FAILED") {
                    this.setState({
                        loading: false,
                        verified: true,
                        failure: false,
                    })
                }
                else{
                    this.setState({
                        loading: false,
                        verified: false,
                        failure: true
                    })
                }

            })
            .catch((error) => {
                let errorMessage =
                    (typeof error === 'string' && error) ||
                    'An error occured, please try again in a moment.';
                // alert(JSON.stringify(error));
                console.log(errorMessage);
                toast.error(errorMessage)
                this.setState({
                    loading: false,
                    failure: true,
                    verified: false,
                })
            });
    }

    render() {
        const {loading, verified, failure} = this.state
        return (
            <div>
                <Loader fullPage loading={loading} text ={"Verifying your transaction" }/>
                {verified &&
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12 col-sm-offset-3">
                            <br/><br/><h2 style={{color:"#0fad00"}}>Success</h2>
                            <img src="/assets/img/check.gif" style={{width:100}}/>
                            <h3 className='mt-5'>Jazakhumullahu Khayran</h3>
                            <p className='mt-2'>Your payment has been confirmed</p>
                            <NavLink to={"/"} className="btn btn-success mt-2"> Proceed</NavLink>
                            <br/><br/>
                        </div>

                    </div>
                </div>
                }

                {
                    failure &&
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-12 col-sm-offset-3">
                                <br/><br/><h2 style={{color:"red"}}>Verification failed</h2>
                                <img src="/assets/img/error.png" style={{width:100}}/>
                                <h3 className='mt-5'>Your payment was not verified</h3>
                                <p className='mt-2'>Please click below button to try verifying again</p>
                                <a href="#" className="btn btn-danger mt-2" onClick={()=> this.verifyTransaction()}> Try again</a>
                                <br/><br/>
                            </div>

                        </div>
                    </div>
                }

                <ToastContainer/>
            </div>
        );
    }
}

export default Verify;
